export default __webpack_public_path__ + "static/media/sendMessage.cd4e2f60.svg";